import { requestGET } from '@/api';
import { InvestmentRevenueEntity } from '@/entities/revenue';

export const getInvestmentRevenues = (): Promise<InvestmentRevenueEntity> =>
  requestGET('/v1/invest/users/me/investments/revenues');
